/*
 * Fleur Québec - bloc « Recette - composition » (snippets/fq-recipe.liquid)
 *
 * Every size panel is rendered by Liquid; the one for the selected variant is visible and the others are [hidden].
 * Prestige dispatches "variant:change" on the product form (bubbling) once the new variant is known, so we follow that
 * event and match on the variant id, never on label text (labels are translated FR/EN). Events from other forms
 * (quick buy, featured product) are ignored. The block is not part of Prestige's partial re-render, so this script is
 * what switches the panel.
 *
 * Animation classes are added here only, so nothing is hidden when JavaScript is off.
 */
(() => {
  if (window.__fqRecipe) return;
  window.__fqRecipe = true;

  const ROOT = '[data-fq-recipe]';
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const replay = (panel) => {
    if (!panel || reduceMotion.matches) return;
    panel.classList.remove('is-entering');
    void panel.offsetWidth; // restart the animation
    panel.classList.add('is-entering');
  };

  const activate = (root, variantId) => {
    let target = null;
    root.querySelectorAll('[data-variant-id]').forEach((panel) => {
      const on = variantId != null && panel.getAttribute('data-variant-id') === String(variantId);
      panel.hidden = !on;
      panel.classList.toggle('is-active', on);
      if (on) target = panel;
    });
    // .fq-recipe--empty also brings back the template's static note (see the :has() rule in the snippet)
    root.classList.toggle('fq-recipe--empty', !target);
    const status = root.querySelector('[data-fq-recipe-status]');
    if (status) status.textContent = target ? target.getAttribute('data-status') || '' : '';
    replay(target);
  };

  document.addEventListener('variant:change', (event) => {
    const form = event.target;
    // Read the attribute: on a product form, form.id is the <input name="id"> (variant id field), not the form's id.
    const formId = form instanceof HTMLFormElement ? form.getAttribute('id') : null;
    if (!formId) return;
    const variant = event.detail && event.detail.variant;
    document.querySelectorAll(ROOT).forEach((root) => {
      if (root.getAttribute('data-form-id') === formId) {
        activate(root, variant && variant.id != null ? variant.id : null);
      }
    });
  });

  // "Included" tooltip on Présenté dans chips: Escape dismisses it (hover and focus), per WCAG 1.4.13.
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const focused = document.activeElement && document.activeElement.closest
      ? document.activeElement.closest('.fq-recipe__chip--vessel') : null;
    if (focused) focused.blur();
    document.querySelectorAll('.fq-recipe__chip--vessel:hover').forEach((chip) => chip.classList.add('is-tip-dismissed'));
  });
  document.addEventListener('mouseout', (event) => {
    const chip = event.target && event.target.closest ? event.target.closest('.fq-recipe__chip--vessel') : null;
    if (chip && !chip.contains(event.relatedTarget)) chip.classList.remove('is-tip-dismissed');
  });

  // First reveal: animate the visible panel once when the card scrolls into view.
  const observer = 'IntersectionObserver' in window
    ? new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          replay(entry.target.querySelector('.fq-recipe__panel.is-active'));
          observer.unobserve(entry.target);
        });
      }, { threshold: 0.25 })
    : null;

  const init = (scope) => {
    (scope || document).querySelectorAll(ROOT).forEach((root) => {
      if (root.hasAttribute('data-fq-ready')) return;
      root.setAttribute('data-fq-ready', '');
      if (observer) observer.observe(root);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  // Theme editor re-renders, and Prestige swapping the whole product info for combined listings.
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('product:rerender', () => requestAnimationFrame(() => init()), true);
})();
